module.exports = __webpack_public_path__ + "static/alum5-fe2f8742f74a1768134ea84e222a3e21.png";